import Instance from '../../../../utils/Axios';

const EnviarValidacaoIndividualRH = (ydata) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .post('/obras/validacao/recursoshumanos', { ydata })
      .then(({ data }) => {
        console.log(data);
        if (stateToken) {
          dispatch({ type: 'POST_VALIDACAO_INDIVIDUAL_RH', payload: data });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default EnviarValidacaoIndividualRH;
